'use client';

import Link from 'next/link';
import { ExternalLink } from 'lucide-react';

export interface Source {
  videoId: string;
  videoTitle: string;
  channelName: string;
  startTime: number | null;
}

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

interface Props {
  sources: Source[];
}

export default function CitationCard({ sources }: Props) {
  if (sources.length === 0) return null;

  return (
    <div className="mt-4 space-y-2">
      <p style={{ color: 'var(--color-muted)', letterSpacing: '0.12em' }} className="text-xs">
        参照した動画
      </p>
      {sources.map((s, i) => {
        const ytUrl = `https://www.youtube.com/watch?v=${s.videoId}${s.startTime ? `&t=${Math.floor(s.startTime)}` : ''}`;
        return (
          <Link
            key={`${s.videoId}-${i}`}
            href={`/library/videos/${s.videoId}`}
            style={{ border: '1px solid var(--color-border)', backgroundColor: 'var(--color-card)' }}
            className="flex items-start justify-between gap-3 p-3 rounded-lg transition-all duration-300 hover:border-[var(--color-accent)] group"
          >
            <div className="flex-1 min-w-0">
              <p style={{ color: 'var(--color-text)' }} className="text-sm font-light leading-snug truncate">
                <span style={{ color: 'var(--color-muted)' }} className="mr-2 text-xs">
                  [{i + 1}]
                </span>
                {s.videoTitle}
              </p>
              <p style={{ color: 'var(--color-muted)' }} className="text-xs mt-0.5">
                {s.channelName}
                {s.startTime !== null && s.startTime > 0 && (
                  <span className="ml-2">▶ {formatTime(s.startTime)}〜</span>
                )}
              </p>
            </div>
            <a
              href={ytUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              title="YouTubeで見る"
              className="flex-shrink-0 mt-0.5 p-1 rounded hover:bg-[var(--color-border)] transition-colors"
            >
              <ExternalLink
                size={14}
                style={{ color: 'var(--color-muted)' }}
                className="group-hover:text-[var(--color-accent)] transition-colors"
              />
            </a>
          </Link>
        );
      })}
    </div>
  );
}
